export const RENTAL_PORTAL_MOCK_FIXTURE_WEEK = '2026-09-14'

export const RENTAL_PORTAL_MOCK_WEEK_OPTIONS = { weekStartsOn: 1 }

export const RENTAL_PORTAL_MOCK_DATE_FORMAT = 'yyyy-MM-dd'

export const RENTAL_PORTAL_MOCK_DATE_PATTERN =
  /^(\d{4}-\d{2}-\d{2})(T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})?)?$/
